// import React, { useEffect, useState } from 'react'
// import "./FinalExamContainer.css"
// import { Container, Spinner } from 'react-bootstrap'
// import { useSelector } from 'react-redux';
// function FinalExamContainer() {
//   const { list: courses } = useSelector((state) => state.courses);
//   const { list: finalExam } = useSelector((state) => state.finalExam);
//   const examDuration = 1 * 60; // ⬅️ 5 دقائق (غيرها كما تريد)
// console.log(finalExam,"finalExam");

//   const [timeLeft, setTimeLeft] = useState(examDuration);
//   const [answer, setAnswers] = useState('');

//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (timeLeft <= 0) {
//       handleSubmit(); // ⬅️ الوقت انتهى → اعرض النتيجة تلقائيًا
//       return;
//     }

//     const interval = setInterval(() => {
//       setTimeLeft((prev) => prev - 1);
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [timeLeft]);


// const handleSubmit = () => {
//   const result = finalExam.map(q => (
//     console.log(q),
//     {
//     id: q.id,
//     question: q.question,
//     correct: q.correct_answer,
//     userAnswer: answer[q.id],
//     isCorrect: q.correct_answer === answer[q.id]
//   }));

//   console.log("RESULT => ", result);
//   alert("تم تصحيح الإجابات ✔️ شوف الـ console");
// };

//   return (
//     <div className='final_exam_container'>
//       <Container>
//         <h5 className='my-4'>الاختبار النهائي</h5>
//         <h5 className='my-4'>{timeLeft}</h5>
//         <div className='lesson_objectives p-4 mb-4'>
//           {finalExam.map((item, index) => {
//             console.log(item?.options);

//             return (
//               <div className='border-bottom mb-3 pb-3'>
//                 <h5>{index + 1 + "-"}{" "}{item?.question}</h5>
//                 <ul>
//                   {item?.options.map((op) => {
//                     return (
//                       <li className={`py-2 option_answer ${answer[item.id] === op.option ? "selected_option" : ""}`}

//             onClick={() => {
//   setAnswers(prev => ({
//     ...prev,
//     [item.id]: op.option   // تخزين إجابة السؤال
//   }))
// }}
//                       >              {op?.option}
//                       </li>
//                     )
//                   })}
//                 </ul>
//               </div>
//             )
//           })}
//           <div className='d-flex justify-content-center '>
//             <div className="text-center w-25">
//               {
//                 loading ?

//                   <div className=" bg-secondary py-2 rounded text-white d-flex align-items-center justify-content-center" onClick={handleSubmit}>
//                     <p className='mb-0 mx-1'>
//                       عرض النتيجة
//                     </p>
//                     <Spinner size='l' />

//                   </div>

//                   :

//                   <div className=" btn-block py-2 rounded text-white" onClick={handleSubmit} style={{ cursor: "pointer" }}>عرض النتيجة</div>

//               }

//             </div>

//           </div>
//         </div>
//       </Container>
//     </div>
//   )
// }
// export default FinalExamContainer


import React, { useEffect, useState } from "react";
import "./FinalExamContainer.css";
import { Container, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import axios from "axios";
import { apiUrl } from "../../constant/apiUrl";

function FinalExamContainer() {
  const { list: finalExam } = useSelector((state) => state.finalExam);
  console.log(finalExam);
  
  const { auth } = useSelector((state) => state);
  const token = auth.access_token; // Assuming token is stored in auth slice

  const examDuration = 100; // 1 دقيقة (عدّل كما تريد)
  const [timeLeft, setTimeLeft] = useState(examDuration);

  const [answers, setAnswers] = useState({}); // <-- مهم جدا
  const [showResult, setShowResult] = useState(false);
  const [score, setScore] = useState(0);
  const [examEnded, setExamEnded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeBG, setActiveBG] = useState("");


  // ⏱ عداد الوقت
  useEffect(() => {
    if (timeLeft <= 0 && !showResult) {
      endExamAutomatically(); // ← حل المشكلة هنا
      return;
    }

    const interval = setInterval(() => setTimeLeft((t) => t - 1), 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);

  // 🟨 user selects answer
  const selectAnswer = (qId, optionId) => {
    if (examEnded) return; // لا تغيّر بعد الانتهاء

    setAnswers((prev) => ({
      ...prev,
      [qId]: optionId,
    }));
  };
console.log(finalExam);

  // 🧮 correct exam
  const calculateScore = () => {
    let correctCount = 0;

    finalExam.forEach((question) => {
      const selectedOptionId = answers[question.id]; // ← جواب المستخدم

      const correctOption = question.options.find(
        (op) => op.is_correct === 1
      );

      if (correctOption && selectedOptionId === correctOption.id) {
        correctCount++;
      }
    });

    return correctCount;
  };

  // انتهاء الوقت تلقائياً
  const endExamAutomatically = () => {
    const finalScore = calculateScore();
    setScore(finalScore);
    setShowResult(true);
    setExamEnded(true);
  };

  // زر "عرض النتيجة"
//   const handleSubmit =async () => {
//             try {
//                             const response = await axios.post(`${apiUrl}/enrollments/${2}/final-exam/submit`, {

//     "answers": [
//         {
//             "final_exam_question_id": 2,
//             "final_exam_question_option_id": 3
//         }
//     ]

//                             }, {
//                               headers: {
//                                 Authorization: `Bearer ${token}`,
//                               },
//                             });
//                   const finalScore = calculateScore();
//     setScore(finalScore);

//     setShowResult(true);
//     setExamEnded(true);

//     setLoading(false);



//                           } catch (error) {

// console.log(error);


//                           }

//   };

const handleSubmit = async () => {
  setLoading(true);

  try {
    // Build body from user's answers
    const apiBody = {
      answers: Object.keys(answers).map((qId) => ({
        final_exam_question_id: Number(qId),
        final_exam_question_option_id: answers[qId],
      })),
    };

    console.log("BODY SENT TO API:", apiBody);

    const response = await axios.post(`${apiUrl}/courses/${1}/final-exam/submit`, apiBody,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    // Calculate score locally
    const finalScore = calculateScore();
    setScore(finalScore);
    setShowResult(true);
    setExamEnded(true);
  } catch (error) {
    console.log(error);
  }

  setLoading(false);
};


  return (
    <div className="final_exam_container">
      <Container>
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="my-4">الاختبار النهائي</h5>
          {showResult &&
            <h4>
              نتيجتك: {score} من {finalExam.length}
            </h4>
          }
        </div>
        <h5 className="my-4">
          {examEnded ? "انتهى الوقت!" : `${timeLeft} ثانية`}
        </h5>

        <div className="lesson_objectives p-4 mb-4">
          {finalExam?.map((item, index) => {
            const correctOption = item.options.find(
              (op) => op.is_correct === 1
            );

            return (
              <div key={item.id} className="border-bottom mb-3 pb-3">
                <h5>
                  {index + 1}- {item.question}
                </h5>

                <ul>
                  {item.options.map((op) => {
                    const isSelected = answers[item.id] === op.id;

                    let bgColor = "";

                    // if (showResult) {
                    //   if (op.id === correctOption.id) bgColor = "lightgreen";
                    //   else if (isSelected) bgColor = "#ffb3b3";
                    // } else if (isSelected) {
                    //   bgColor = "#e6e6e6";
                    // }
                    if (showResult) {
                      const userAnswered = answers[item.id]; // هل المستخدم جاوب السؤال؟

                      if (userAnswered) {
                        // ✔ المستخدم جاوب هذا السؤال
                        if (op.id === correctOption.id) {
                          bgColor = "lightgreen"; // الإجابة الصحيحة
                        } else if (isSelected) {
                          bgColor = "#ffb3b3"; // الإجابة الخاطئة المختارة
                        }
                      }
                      // ❌ لو المستخدم لم يجاوب السؤال → لا تلوّن شيء
                    } else if (isSelected) {
                      bgColor = "#e6e6e6";          // ← لون يوضح اختيار المستخدم
                    }

                    return (
                      <li
                        key={op.id}
                        className="py-2 option_answer"
                        style={{
                          cursor: examEnded ? "not-allowed" : "pointer",
                          backgroundColor: bgColor,
                          borderRadius: "6px",
                          opacity: examEnded ? 0.6 : 1,
                        }}
                        onClick={() => selectAnswer(item.id, op.id)}
                      >
                        {op.option}
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}

          {/* زر عرض النتيجة */}
          {!showResult && (
            <div className="d-flex justify-content-center">
              <div className="text-center w-25">
                {loading ? (
                  <div className="bg-secondary py-2 rounded text-white d-flex align-items-center justify-content-center">
                    <p className="mb-0 mx-1">عرض النتيجة</p>
                    <Spinner size="l" />
                  </div>
                ) : (
                  <div
                    className="btn-block py-2 rounded text-white"
                    onClick={handleSubmit}
                    style={{ cursor: "pointer", background: "#000" }}
                  >
                    عرض النتيجة
                  </div>
                )}
              </div>
            </div>
          )}

          {/* إظهار النتيجة */}
          {showResult && (
            <div className="text-center mt-4">


              <button
                className="btn btn-dark mt-3"
                onClick={() => window.location.reload()}
              >
                إعادة المحاولة
              </button>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
}

export default FinalExamContainer;
